import { DemandesFormation } from '../equipe/DemandesFormation.jsx';
import { roleCan } from '../../lib/access';
import { useState } from 'react';
import { Shell } from '../../components/layout/Shell.jsx';
import { Bar } from '../../components/ui/Bar.jsx';
import { Btn } from '../../components/ui/Btn.jsx';
import { Card } from '../../components/ui/Card.jsx';
import { ConventionA4View } from '../documents/ConventionA4View.jsx';
import { genConvention } from '../../lib/contracts';
import { formationDu } from '../../lib/costs';
import { DEVISE, fmt } from '../../lib/currency';
import { C } from '../../theme/palette';

export function FormationPage({
  onNav,
  soc,
  employes,
  setEmployes,
  estMixte,
  univers,
  setUnivers,
}) {
  const list = employes || [];
  const [selId, setSelId] = useState(list[0] ? list[0].id : null);
  const [showA4, setShowA4] = useState(false);
  const emp = list.find((e) => String(e.id) === String(selId)) || null;
  const f = (emp && emp.formation) || {};
  const upd = (patch) =>
    emp &&
    setEmployes((p) =>
      p.map((e) =>
        e.id === emp.id ? { ...e, formation: { ...(e.formation || {}), ...patch } } : e,
      ),
    );
  const _l = {
    fontSize: 11,
    fontWeight: 800,
    color: C.muted,
    textTransform: 'uppercase',
    margin: '0 0 5px',
  };
  const _is = {
    width: '100%',
    border: '1px solid ' + C.border,
    borderRadius: 10,
    padding: '9px 11px',
    fontSize: 12.5,
    boxSizing: 'border-box',
    marginBottom: 9,
  };
  const du = formationDu(f);
  return (
    <Shell
      active="plus"
      onNav={onNav}
      soc={soc}
      back
      onBack={() => onNav('plus')}
      pageTitle="🎓 Formation"
      estMixte={estMixte}
      univers={univers}
      setUnivers={setUnivers}
    >
      {showA4 && emp ? (
        <ConventionA4View emp={emp} soc={soc} onClose={() => setShowA4(false)} />
      ) : null}
      {roleCan('envoyer') && <DemandesFormation />}
      <div style={{ fontSize: 9.5, color: C.muted, margin: '0 2px 12px', lineHeight: 1.5 }}>
        Choisis un employé : ses coordonnées (nom, adresse, N° AVS, fonction) se remplissent
        automatiquement depuis sa fiche. Génère la convention, puis imprime-la ou envoie-la en A4.
      </div>
      {list.length === 0 ? (
        <Card>
          <div style={{ padding: 20, textAlign: 'center', color: C.muted, fontSize: 11 }}>
            Ajoute d'abord un employé (Plus → Équipe & paie → Nouvel employé).
          </div>
        </Card>
      ) : (
        <div>
          <Card style={{ marginBottom: 12 }}>
            <div style={{ padding: 13 }}>
              <div style={_l}>Employé concerné</div>
              <select
                value={selId || ''}
                onChange={(e) => setSelId(e.target.value)}
                style={{ ..._is, marginBottom: 0 }}
              >
                {list.map((e) => (
                  <option key={e.id} value={e.id}>
                    {((e.prenom || '') + ' ' + (e.nom || '')).trim()}
                    {e.role ? ' — ' + e.role : ''}
                  </option>
                ))}
              </select>
            </div>
          </Card>
          {emp ? (
            <div>
              <Card style={{ marginBottom: 12 }}>
                <Bar icon="👤" title="Coordonnées (reprises du contrat)" color={C.navy} />
                <div
                  style={{ padding: '12px 14px', fontSize: 11.5, lineHeight: 1.7, color: C.ink }}
                >
                  <div>
                    <b>{((emp.prenom || '') + ' ' + (emp.nom || '')).trim()}</b>
                    {emp.role ? ' — ' + emp.role : ''}
                  </div>
                  <div style={{ color: C.grey }}>
                    {[emp.adresse, [emp.npa, emp.ville].filter(Boolean).join(' ')]
                      .filter(Boolean)
                      .join(', ') || 'Adresse non renseignée'}
                  </div>
                  <div style={{ color: C.grey }}>
                    {emp.avs ? 'N° AVS ' + emp.avs : 'N° AVS non renseigné'}
                    {emp.dateEmbauche ? ' · engagé le ' + emp.dateEmbauche : ''}
                  </div>
                  {!emp.adresse || !emp.avs ? (
                    <div style={{ fontSize: 9, color: C.amber, marginTop: 6 }}>
                      💡 Complète l'adresse / le N° AVS dans sa fiche (Équipe & paie) pour une
                      convention complète.
                    </div>
                  ) : null}
                </div>
              </Card>
              <Card style={{ marginBottom: 12 }}>
                <Bar icon="🎓" title="La formation" color={C.purple} />
                <div style={{ padding: 13 }}>
                  <div style={_l}>Nom de la formation</div>
                  <input
                    value={f.nom || ''}
                    onChange={(e) => upd({ nom: e.target.value })}
                    placeholder="Ex. Permis cariste, CFC, brevet..."
                    style={_is}
                  />
                  <div style={{ display: 'flex', gap: 8 }}>
                    <div style={{ flex: 1 }}>
                      <div style={_l}>Coût payé (CHF)</div>
                      <input
                        type="number"
                        value={f.cout || ''}
                        onChange={(e) => upd({ cout: +e.target.value || 0 })}
                        style={_is}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={_l}>Engagement (mois)</div>
                      <input
                        type="number"
                        value={f.engagementMois || ''}
                        onChange={(e) => upd({ engagementMois: +e.target.value || 0 })}
                        style={_is}
                      />
                    </div>
                  </div>
                  <div style={{ display: 'flex', gap: 8 }}>
                    <div style={{ flex: 1 }}>
                      <div style={_l}>Début</div>
                      <input
                        type="date"
                        value={f.debut || ''}
                        onChange={(e) => upd({ debut: e.target.value })}
                        style={_is}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={_l}>Mensualité (CHF)</div>
                      <input
                        type="number"
                        value={f.mensualite !== undefined ? f.mensualite : 500}
                        onChange={(e) => upd({ mensualite: +e.target.value || 0 })}
                        style={_is}
                      />
                    </div>
                  </div>
                  {+f.cout > 0 && +f.engagementMois > 0 ? (
                    <div
                      style={{
                        background: C.amber + '14',
                        borderRadius: 9,
                        padding: '9px 12px',
                        marginBottom: 9,
                      }}
                    >
                      <div style={{ fontSize: 8.5, color: C.amber, fontWeight: 700 }}>
                        💡 S'il part maintenant, il rembourse
                      </div>
                      <div style={{ fontSize: 17, fontWeight: 900 }}>
                        {DEVISE} {fmt(du)}
                      </div>
                    </div>
                  ) : null}
                  {f.texte ? (
                    <div>
                      <div style={_l}>Convention (modifiable)</div>
                      <textarea
                        value={f.texte}
                        onChange={(e) => upd({ texte: e.target.value })}
                        style={{
                          width: '100%',
                          minHeight: 140,
                          border: '1px solid ' + C.amber,
                          borderRadius: 10,
                          padding: 11,
                          fontSize: 10.5,
                          lineHeight: 1.6,
                          fontFamily: 'inherit',
                          boxSizing: 'border-box',
                          outline: 'none',
                        }}
                      />
                      <div style={{ display: 'flex', gap: 7, marginTop: 7 }}>
                        <Btn
                          label="↻ Régénérer"
                          sm
                          ghost
                          color={C.grey}
                          onClick={() => upd({ texte: genConvention(emp, f, soc) })}
                        />
                        <Btn
                          label="🗑 Effacer"
                          sm
                          ghost
                          color={C.red}
                          onClick={() => upd({ texte: '' })}
                        />
                      </div>
                    </div>
                  ) : (
                    <Btn
                      label="📄 Générer la convention (auto-remplie)"
                      color={C.purple}
                      full
                      onClick={() => upd({ texte: genConvention(emp, f, soc) })}
                    />
                  )}
                  <div style={{ marginTop: 9 }}>
                    <Btn
                      label="📄 Voir / Imprimer en A4 (signature + tampon)"
                      color={C.navy}
                      full
                      onClick={() => {
                        if (!f.texte) {
                          upd({ texte: genConvention(emp, f, soc) });
                        }
                        setShowA4(true);
                      }}
                    />
                  </div>
                </div>
              </Card>
            </div>
          ) : null}
        </div>
      )}
    </Shell>
  );
}
